// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__1GeHz","link":"style_link__2fM2C","error":"style_error__3GLPo"};